import {
  Container,
  Desc,
  Image,
  Left,
  Main,
  Number,
  Right,
  Title,
} from "./Project.Elements";
import "./project.css";

const Project = ({ side }) => {
  return (
    <>
      {side === "left" ? (
        <Container>
          <Left side={side}>
            <Main>
              <Number>01</Number>
              <Title>A Real time Chat application</Title>
              <Desc>
                Designed & Build a real time chat application using MERN Stack
                will help users to have a single chat along with group chat
                using advance technologies like Context API, Socket IO.
              </Desc>
            </Main>
          </Left>
          <Right className='card'>
            <Image
              src='https://cdn.dribbble.com/users/1223844/screenshots/8771661/media/8a3d62f20f84884fd99ba55bc79ccb81.png'
              alt=''
              className='card-image'
            />
          </Right>
        </Container>
      ) : (
        <Container>
          <Right className='card'>
            <Image
              src='https://cdn.dribbble.com/users/1223844/screenshots/8771661/media/8a3d62f20f84884fd99ba55bc79ccb81.png'
              alt=''
              className='card-image'
            />
          </Right>
          <Left side={side}>
            <Main>
              <Number>02</Number>
              <Title>Customer Segmentation</Title>
              <Desc>
                This is a Machine Learning project, will create segments of
                Customers using the K-Means Clustering alogirthm. this project
                helps business in analysis & decision making for better future.
              </Desc>
            </Main>
          </Left>
        </Container>
      )}
    </>
  );
};

export default Project;
